import { API_URL, STAGE } from "../constants";
import axios, { type AxiosRequestConfig } from "axios";
import type { DriverRegistration } from "../types/driver-registration.type";
import type { DriverRegistrationShare } from "../types/driver-registration-share.type";

export function getDriverRegistrations(
  password: string,
  config?: AxiosRequestConfig
): Promise<{
  driverRegistrations: DriverRegistration[];
}> {
  return axios
    .get(
      `${API_URL}/${STAGE}/v2/cms/driver-registrations/without-org-relationship`,
      {
        ...config,
        headers: {
          password,
          ...config?.headers,
        },
      }
    )
    .then((data) => data.data);
}

export function shareDriverRegistration(
  password: string,
  driverRegistrationId: string,
  organizationId: string
): Promise<{ driverRegistrationShare: DriverRegistrationShare }> {
  return axios
    .post(
      `${API_URL}/${STAGE}/v2/cms/driver-registrations/${driverRegistrationId}/share`,
      {
        organizationId,
      },
      {
        headers: {
          password,
        },
      }
    )
    .then((data) => data.data);
}

export function acceptDriverRegistration(
  driverRegistrationId: string,
  organizationId: string
) {
  return axios
    .post(
      `${API_URL}/${STAGE}/v2/cms/driver-registrations/${driverRegistrationId}/accept/${organizationId}`
    )
    .then((data) => data.data);
}

export function declineDriverRegistration(
  driverRegistrationId: string,
  organizationId: string
) {
  return axios
    .post(
      `${API_URL}/${STAGE}/v2/cms/driver-registrations/${driverRegistrationId}/decline/${organizationId}`
    )
    .then((data) => data.data);
}
